import React, { useEffect, useState } from 'react';
import '@fontsource/oswald';
import '@fontsource/great-vibes';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Home from './components/Home';
import PrivacyPolicy from './components/PrivacyPolicy';
import Footer from './components/Footer';
import ContactUs from './components/Contact';
import AboutUs from './components/About';
import ConciergeService from './components/ConciergeService';
import FAQ from './components/FAQ';
import ScrollToTop from './components/ScrollToTop';
import IntroVideo from './components/IntroVideo'; // import the video component
import Book from './components/Book';
import TermsOfUse from './components/TermsOfUse';
import JackpotVip from './components/JackpotVip';

function App() {
  const [showIntro, setShowIntro] = useState(false);

  useEffect(() => {
    const visited = localStorage.getItem('visited');
    if (!visited) {
      setShowIntro(true);
      localStorage.setItem('visited', 'true');
    }
  }, []);

  if (showIntro) {
    return <IntroVideo onFinish={() => setShowIntro(false)} />;
  }

  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/about" element={<AboutUs />} />
          <Route exact path="/concierge-service" element={<ConciergeService />} />
          <Route exact path="/contact" element={<ContactUs />} />
          <Route exact path="/request-quote" element={<Book />} />
          <Route exact path="/jackpot-vip" element={<JackpotVip />} />

          <Route exact path="/FAQ" element={<FAQ />} />
          <Route exact path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
